import { unwrap } from "@/shared/api/client";

/** One page of a cursor-paginated list: its items and the cursor of the next page, if any. */
export interface PageOf<T> {
  items: T[];
  nextCursor: string | null;
}

interface PageResult<T> {
  data?: { data: T[]; meta: { next_cursor: string | null } };
  error?: unknown;
  response: Response;
}

/** Unwrap a paginated openapi-fetch result (`{data: [...], meta: {next_cursor}}`). */
export async function unwrapPage<T>(request: Promise<PageResult<T>>): Promise<PageOf<T>> {
  const page = await unwrap(
    request.then((result) => ({
      ...result,
      data: result.data === undefined ? undefined : { data: result.data },
    })),
  );
  return { items: page.data, nextCursor: page.meta.next_cursor };
}

/** Every item of an infinite query's pages, in order. */
export function itemsOf<T>(pages: readonly PageOf<T>[] | undefined): T[] {
  return pages?.flatMap((page) => page.items) ?? [];
}
